import { useEffect, useState } from "react";
import {
  DeepMap,
  FieldErrors,
  UseFormRegister,
  UseFormSetValue,
} from "react-hook-form";
import { RiErrorWarningLine } from "react-icons/ri";
import { FormValues } from ".";
import Tooltipaction from "../../../components/Tooltip/tooltipAction";
import { useAppSelector } from "../../../store/hooks";

interface Props {
  register: any;
  setValue: any;
  errors: any;
}
const Addressinput = ({ register, setValue, errors }: Props) => {
  const { extra, employee } = useAppSelector((state) => state.user);
  // const QA = process.env.REACT_APP_QA;
  const addressDefault = extra?.address
    ? extra?.address
    : employee.location_address1;

  const [address, setAdress] = useState<string>(addressDefault);
  const { onChange: onChangePhone, ...restAddress } = register("address");

  const handleChangeAddress = (e: React.FormEvent<HTMLInputElement>) => {
    let valueAddress = e.currentTarget.value;
    if (valueAddress.length <= 50) {
      setAdress(valueAddress);
      setValue("address", valueAddress);
    }
  };
  useEffect(() => {
    setAdress(addressDefault);
    setValue("address", addressDefault);
  }, [extra?.address]);

  return (
    <div className="c-input">
      <div className="c-input__header">
        <span className="c-input__title">Street Address</span>
        <Tooltipaction
          placement="top"
          text="Please add your corporate or retail office information."
          margin={5}
        >
          <div className="c-input__icon">
            <RiErrorWarningLine />
          </div>
        </Tooltipaction>
      </div>
      <input
        type="text"
        className="c-input__input"
        value={address}
        onChange={handleChangeAddress}
        {...restAddress}
      />
    </div>
  );
};
export default Addressinput;
